import React, { useState, useEffect, createContext, useContext } from 'react'
import { lightTokens } from './tokens/light.js'
import { darkTokens } from './tokens/dark.js'
import { flattenTokens, applyVars } from './tokenUtils'

const ThemeCtx = createContext(null)

export function ThemeProvider({ children }) {
  const getInitial = () => 'light'

  const [mode, setMode] = useState(getInitial)

  useEffect(() => {
    const root = document.documentElement
    root.setAttribute('data-theme', 'light')
    applyVars(flattenTokens(lightTokens), root)

    try {
      localStorage.setItem('theme', 'light')
    } catch {}
  }, [])

  // No dark mode toggle needed anymore
  const toggle = () => {}

  return <ThemeCtx.Provider value={{ mode: 'light', toggle }}>{children}</ThemeCtx.Provider>
}

export const useTheme = () => {
  const ctx = useContext(ThemeCtx)
  if (!ctx) throw new Error('useTheme must be within ThemeProvider')
  return ctx
}
